import { render, staticRenderFns } from "./OrgsList.vue?vue&type=template&id=5eda4aae&scoped=true"
import script from "./OrgsList.vue?vue&type=script&lang=js"
export * from "./OrgsList.vue?vue&type=script&lang=js"
import style0 from "./OrgsList.vue?vue&type=style&index=0&id=5eda4aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda4aae",
  null
  
)

export default component.exports